import { ToastErrorComponent, ToastSuccessComponent, ToastWarningComponent } from 'src/app/layouts/main-layout/components/toast-types/toast-types.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
export class ToastCustomService {
    constructor(_snackBar) {
        this._snackBar = _snackBar;
        this.durationInSeconds = 5;
        this.horizontalPosition = 'end';
        this.verticalPosition = 'top';
        this.handlerType = {
            success: ToastSuccessComponent,
            warning: ToastWarningComponent,
            error: ToastErrorComponent
        };
        this.handlerClass = {
            success: 'snack-bar-success',
            warning: 'snack-bar-warning',
            error: 'snack-bar-error'
        };
    }
    show(type, title, subtitle) {
        const snackBarRef = this._snackBar.openFromComponent(this.handlerType[type], {
            duration: this.durationInSeconds * 1000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: this.handlerClass[type]
        });
        snackBarRef.instance.title = title;
        snackBarRef.instance.subtitle = subtitle;
    }
}
ToastCustomService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ToastCustomService_Factory() { return new ToastCustomService(i0.ɵɵinject(i1.MatSnackBar)); }, token: ToastCustomService, providedIn: "root" });
